import { useState, useCallback } from "react";
import axios from 'axios';
import config from '../config.js';
import { WqToast as toast } from "../utils/themedToast";
import { showLoader, hideLoader } from "../utils/loader";


export const useBankTransfer = () => {
    const [transferData, setTransferData] = useState(null);
    const tranId = sessionStorage.getItem("tranId") || new URLSearchParams(window.location.search).get("_tranId");
    
    const initBankTransfer = useCallback(
        async () => {
        // prevent duplicate calls
        if (transferData) return;
  
        try {
            showLoader();
            if (!tranId) throw new Error("Failed to generate transaction ID");
            const header = {
                headers: {
                    'Content-Type': 'application/json',
                    'Client-Type': 'CORPORATE',
                    'Client-Id': 'WAYAQUICK'
                }
            }
  
        const accountRes = await axios.get(`${config.API_ROOT_ADDRESS}/api/v1/request/transfer-account/${tranId}`, header)
        const accountData = accountRes?.data?.data;
  
          setTransferData({
            tranId,
            accountData,
          });
        } catch (err) {
          toast.error("Failed to initialize bank transfer");
        } finally {
            hideLoader();
        }
      },
      [transferData, tranId]
    );
  
    const resetTransfer = () => {
      setTransferData(null);
      sessionStorage.removeItem("tranId");
    };
  
    return {
      transferData,
      initBankTransfer,
      resetTransfer,
    };
  };

export const useFetchBanksUssdList = () => {
    const [banks, setBanks] = useState([]);
  
    const initUssdBankList = useCallback(
      async () => {
        if (banks.length > 0) return;
  
        try {
          showLoader();
            const bankListRes = await axios.get(`${config.API_ROOT}/ussd-service/api/v2/bank/fetch-all`);
           
          const tempBank = bankListRes.data.data.map((bank) => ({
            label: bank.bankName,
            value: bank.bankId,
          }));
          setBanks(tempBank);
        } catch (err) {
          toast.error("Fetching banks failed.", {
            style: {
              // background: "#fff",
            //   color: "#ae1111",
            },
          });
        } finally {
          hideLoader();
        }
      },
      [banks]
    );
  
    return {
      banks,
      initUssdBankList,
    };
  };